import { useEffect, useState } from 'react'
import { Package } from '../../../models'

export default function usePastImagesPricelist() {
  const [pricelist, setPricelist] = useState()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)

    Package
      .where({ slug: 'past-images' })
      .selectExtra(['defaultBackgroundUrl'])
      .first()
      .then((res) => setPricelist(res.data))
      .finally(() => setLoading(false))
  }, [])

  return { loading, pricelist }
}
